import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  DialogActions,
  Button,
  Box,
  FormHelperText,
  Alert,
  Snackbar,
  AlertColor,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import { UUID_CHARACTER_LIMIT } from "../../../utils/ValidationHelper";
import RequiredLabel from "../../atoms/RequiredLabel";
import React from "react";
import ConfirmDialog from "../../molecules/ConfirmDialog";

interface SDCRegistrationModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAlertSeverity: React.Dispatch<React.SetStateAction<AlertColor>>;
  setSnackbarMessage: React.Dispatch<React.SetStateAction<string>>;
}

const SDCRegistrationModal: React.FC<SDCRegistrationModalProps> = ({
  open,
  setOpen,
  setSnackbarOpen,
  setAlertSeverity,
  setSnackbarMessage,
}) => {
  const [sdcSn, setSdcSn] = useState("");
  const [memo, setMemo] = useState("");
  // const [operation, setOperation] = useState("有効");

  // 確認ダイアログ
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const CHARACTER_LIMIT = 50; // 文字数制限を定義

  const [validationErrors, setValidationErrors] = useState({
    sdcSn: "",
    memo: "",
  });

  const handleValidation = () => {
    const errors = {
      sdcSn: !sdcSn ? "SDCSNは必須です" : "",
      memo:
        memo.length > CHARACTER_LIMIT
          ? `メモは${CHARACTER_LIMIT}文字以内で入力してください`
          : "",
    };
    setValidationErrors(errors);
    return !Object.values(errors).some((error) => error !== "");
  };

  const handleOperationChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    // setOperation((event.target as HTMLInputElement).value);
  };

  const handleClose = () => {
    // エラーメッセージをリセット
    setValidationErrors({
      sdcSn: "",
      memo: "",
    });

    // 入力内容をリセット
    setSdcSn("");
    setMemo("");
    // setOperation("有効");

    setOpen(false);
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    // 登録処理
    const payload = {
      sdcSerialNumber: sdcSn,
      memo,
    };

    // もしバリデーションエラーがある場合は処理を中断
    if (!handleValidation()) {
      return;
    }

    // JWTトークンを取得します
    const jwtToken = await getJwtTokenFromIdToken();

    // call storeSdc API
    const response = await fetch(process.env.REACT_APP_API_ENDPOINT + "/sdcs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jwtToken,
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      console.log("SDC登録成功");
      setOpenConfirm(true);
    } else {
      console.log("SDC登録失敗しました");
      setSnackbarMessage("SDC登録失敗しました");
      setAlertSeverity("error");
      setSnackbarOpen(true);
    }

    setOpen(false);
    setIsSubmitting(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">新規SDC登録</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="sdcSn"
            label={
              <span>
                SDCSN
                <RequiredLabel />
              </span>
            }
            type="text"
            fullWidth
            value={sdcSn}
            onChange={(e) => {
              setSdcSn(e.target.value);
            }}
            error={!!validationErrors.sdcSn}
            helperText={validationErrors.sdcSn}
          />
          <TextField
            margin="dense"
            id="memo"
            label="管理メモ"
            type="text"
            fullWidth
            value={memo}
            onChange={(e) => {
              setMemo(e.target.value);
            }}
            error={!!validationErrors.memo}
            helperText={validationErrors.memo}
          />
          {/* <FormControl component="fieldset" error={!!validationErrors.operation}>
      <Box display="flex" alignItems="center" marginTop={1}>
        <FormLabel component="legend" style={{ marginRight: "20px", fontSize: "1rem", fontWeight: 400, lineHeight: 1.5 }}>運用<RequiredLabel /></FormLabel>
        <RadioGroup aria-label="operation" name="operation" value={operation} onChange={e => { handleOperationChange(e); }} row >
          <FormControlLabel value="有効" control={<Radio />} label="有効" />
          <FormControlLabel value="無効" control={<Radio />} label="無効" />
        </RadioGroup>
      </Box>
      <FormHelperText>{validationErrors.operation}</FormHelperText>
    </FormControl> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button 
            onClick={(e) => {
              if (isSubmitting) return;
              handleSubmit();
            }} 
            color="primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={24} sx={{ mr: 1 }} />
                登録中...
              </Box>
            ) : (
              "登録"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmDialog
        open={openConfirm}
        onClose={() => {
          setOpenConfirm(false);
        }}
        onConfirm={() => {
          window.location.reload();
        }}
        title="確認"
        description="SDC登録完了しました。"
        showCancelButton={false}
      />
    </>
  );
};

export default SDCRegistrationModal;